// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f108cb8f","124":"a094a9b7","454":"66e8abef","667":"7852609c","697":"3495f092","971":"c52ac59f","990":"5d10419a"}[chunkId] + ".chunk.js";
};